import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from 'src/@shared/common-pages.service';
import { ResponseStatus, ValidationMessage } from 'src/@shared/enum';
import data from 'src/assets/json/states.json';

@Component({
  selector: 'app-add-update-site-preferred-vendors',
  templateUrl: './add-update-site-preferred-vendors.component.html',
  styleUrls: ['./add-update-site-preferred-vendors.component.scss'],

  standalone: false,
})
export class AddUpdateSitePreferredVendorsComponent implements OnInit {
  sitesData: any = [];
  isVisiblePreferredVendorsDrawer = true;
  isLoadingOne: any = false;
  LineStreetAddress: any = false;
  preferredVendorsDrawerTitle: any;
  validationMessage = ValidationMessage;
  @Output() hidePreferredVendorsDrawer = new EventEmitter();
  @Input() selectedPreferredVendorsData: any;
  selectedUnits: any[] = [];
  passwordVisible = false;
  @Input() selectedSiteId: any;
  listOfStates: any = data.States;
  pageSize: number = 10;
  @ViewChild('zipcode') zipcode: any;
  isAddAddressClicked: boolean = false;

  constructor(
    public _cs: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.preferredVendorForm_fb();
  }
  ngOnInit(): void {
    //while edit change modal title
    this.selectedPreferredVendorsData != null
      ? (this.preferredVendorsDrawerTitle = 'Edit Preferred Vendors')
      : (this.preferredVendorsDrawerTitle = 'Add New Preferred Vendors');
    if (this.selectedPreferredVendorsData != null) {
      this.preferredVendorsDrawerTitle = 'Edit Preferred Vendors';
      this._fS.preferredVendorForm.patchValue({
        // companyName: this.selectedPreferredVendorsData.companyName,
        // vendorDisplayName: this.selectedPreferredVendorsData.vendorDisplayName,
        // emailAddress: this.selectedPreferredVendorsData.emailAddress,
        // phoneNumber: this.selectedPreferredVendorsData.phoneNumber,
        // address1: this.selectedPreferredVendorsData.address1,
        // address2: this.selectedPreferredVendorsData.address2,
        // city: this.selectedPreferredVendorsData.city,
        // state: this.selectedPreferredVendorsData.state,
        // zipcode: this.selectedPreferredVendorsData.zipcode,
        // country: this.selectedPreferredVendorsData.country,
        // ispreferredVendorActive: this.selectedPreferredVendorsData.ispreferredVendorActive,
      });
    } else {
      this.preferredVendorsDrawerTitle = 'Add New Preferred Vendors';
    }
  }
  //close drawer
  handleCancel() {
    this.isVisiblePreferredVendorsDrawer = false;
    this.hidePreferredVendorsDrawer.emit({
      hide: this.isVisiblePreferredVendorsDrawer,
      data: null,
    });
  }
  preventDefaults(event: any) {
    event.preventDefault();
    return false;
  }

  //add or update button of drawer clicked
  handleOk() {
    this._fS.preferredVendorForm.value.companyName.trim() === '';
    this._fS.preferredVendorForm.value.vendorDisplayName.trim() === '';
    if (
      this._fS.preferredVendorForm.value.vendorDisplayName.trim() === '' ||
      this._fS.preferredVendorForm.value.companyName.trim() === ''
    ) {
      this._cs.displayMessage('error', 'Only Space Not Allowed');
    }
    if (this._fS.preferredVendorForm.valid) {
      const formValue = this._fS.preferredVendorForm.value;

      const formData = new FormData();
      formData.set('siteId', this.selectedSiteId);
      formData.set('companyName', formValue.companyName.trim());
      formData.set('vendorDisplayName', formValue.vendorDisplayName.trim());
      formData.set('email', formValue.emailAddress);
      formData.set('phoneNumber', formValue.phoneNumber);
      formData.set('streetAddress1', formValue.address1);
      formData.set('streetAddress2', formValue.address2);
      formData.set('city', formValue.city);
      formData.set('state', formValue.state);
      formData.set('zipCode', formValue.zipcode);
      formData.set('country', formValue.country);
      formData.set('isAddLine', this.LineStreetAddress);
      // if (this.selectedPreferredVendorsData == null) {
      this.addVendorsData(formData);
      // } else {
      //   this.editUserData(preferredVendorBody);
      // }
    } else {
      //to fire validations on invalid fields
      Object.values(this._fS.preferredVendorForm.controls).forEach(
        (control: any) => {
          if (control.invalid) {
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
        }
      );
    }
  }

  //add or update date on buttton click
  addVendorsData(preferredVendorBody: any) {
    this.isLoadingOne = true;
    this._cpS.addVendors(preferredVendorBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cs.displayMessage('success', response.message);
          //hide unit drawer
          this.isVisiblePreferredVendorsDrawer = false;
          this.hidePreferredVendorsDrawer.emit({
            hide: this.isVisiblePreferredVendorsDrawer,
            data: response.result,
          });
          this.isLoadingOne = false;
        } else {
          this._cs.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        // this._cs.displayMessage('error', error.message);
        this.isLoadingOne = false;
      }
    );
  }

  broofa() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  focusZipCode(event: any) {
    if (event) {
      this.zipcode.first.nativeElement.focus();
    }
  }

  // addLines()
  // {
  //   this.LineStreetAddress=true
  //   this._fS.preferredVendorForm.patchValue({
  //     streetAddress: this._fS.preferredVendorForm.get('address1').value+'\r\n'+this._fS.preferredVendorForm.get('address2').value,
  //   });

  //   this._fS.preferredVendorForm.get('streetAddress').addValidators([Validators.required,Validators.pattern(/.*\S.*/)])
  // }
  addLines() {
    this.LineStreetAddress = true;
    this._fS.preferredVendorForm.patchValue({
      address1:
        this._fS.preferredVendorForm.get('address1').value != null &&
        this._fS.preferredVendorForm.get('address1').value != ''
          ? this._fS.preferredVendorForm.get('address1').value +
            '\r\n' +
            this._fS.preferredVendorForm.get('address2').value
          : this._fS.preferredVendorForm.get('address2').value,
      address2: '',
    });
  }

  addAddressClicked(event: boolean) {
    this.isAddAddressClicked = event;
  }

  addInternationalAddress(event: any) {
    this.LineStreetAddress = event;
    if (this.LineStreetAddress) {
      const form = this._fS.preferredVendorForm.value;

      const address =
        (form.address1?.trim() ? form.address1.trim() + '\n' : '') +
        (form.address2?.trim() ? form.address2.trim() + '\n' : '') +
        (form.city?.trim() ? form.city.trim() + ', ' : '') +
        (form.state?.trim() ? form.state.trim() + ' ' : '') +
        (form.zipcode?.trim() ? form.zipcode.trim() + '\n' : '') +
        (form.address1?.trim() ||
        form.address2?.trim() ||
        form.city?.trim() ||
        form.state?.trim() ||
        form.zipcode?.trim()
          ? form.country
          : '');

      this._fS.preferredVendorForm.patchValue({
        address1: address,
        address2: '',
        city: '',
        state: '',
        zipcode: '',
        country: '',
      });
    } else {
      this._fS.preferredVendorForm.patchValue({
        address1: '',
        country: 'USA',
      });
    }
  }
}
